import { AxiosResponse } from 'axios';
import { BE_PageClient } from 'services/PageService/VedaApplication/types';
import fetchAPI from 'utils/functions/fetchAPI';
import { getApiTracking } from 'utils/functions/getApiTracking';
import { clientBaseUrl } from '../const';

interface GetClient {
  commandId: string;
  cacheVersion: number | null;
  searchParams?: Record<string, any>;
}

interface ResponseSuccess {
  message: string;
  info: BE_PageClient;
}

/** API được sử dụng để lấy về dữ liệu của page client */
export const getClient = async ({ commandId, cacheVersion, searchParams }: GetClient) => {
  const response: AxiosResponse<ResponseSuccess> = await fetchAPI.request({
    url: getApiTracking({ defaultBaseUrl: `${clientBaseUrl}/${commandId}`, trackingEndpoint: `pages/${commandId}` }),
    params: {
      ...searchParams,
      cacheVersion: cacheVersion !== null ? cacheVersion : undefined,
    },
  });
  return response.data;
};
